import {useEffect} from 'react'
import {JudolEditModalHeader} from './JudolEditModalHeader'
import {JudolEditModalFormWrapper} from './JudolEditModalFormWrapper'

const JudolEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div className='modal-backdrop fade show'></div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_student'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-850px'>
          <div className='modal-content'>
            <JudolEditModalHeader />
            <div className='modal-body scroll-y py-1 px-2 pe-0'>
              <JudolEditModalFormWrapper />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {JudolEditModal}
